import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

export default function DeleteModal(props) {
  const { t } = useTranslation();
  const [show, setShow] = useState(props.show);

  const handleClose = () => props.handleClose();

  useEffect(() => {
    setShow(props.show);
  }, [props]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("COMMON.ATTENTION")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("DELETE_MODAL.CONFIRM_DELETE")} {props.itemName}?</Modal.Body>
        <Modal.Footer>
          <Button variant='warning' onClick={handleClose}>
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              handleClose();
              props.callBackRemove(props.itemRemoveId);
            }}>
            {t("DELETE_MODAL.OK")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}